export default __webpack_public_path__ + "242b2e438fad041261b60ba48a8500a5.png";